var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessengerActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0948 4.93497L21.0815 9.92831C25.5615 12.1683 25.5615 15.8316 21.0815 18.0716L11.0948 23.065C4.37482 26.425 1.63315 23.6716 4.99315 16.9633L6.00815 14.945C6.26482 14.4316 6.26482 13.58 6.00815 13.0666L4.99315 11.0366C1.63315 4.32831 4.38649 1.57497 11.0948 4.93497Z",
    stroke: "#292D32",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34668 14H12.6467",
    stroke: "#292D32",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 7,
    r: 4.59375,
    fill: "#00B2EF",
    stroke: "white",
    strokeWidth: 1.3125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerActive);
export default __webpack_public_path__ + "static/media/messenger-active.9d87e6a01c1b1702a50c4507c8014742.svg";
export { ForwardRef as ReactComponent };